import React, { useState, useEffect } from "react";
import newsData from "../../data/news.json";
import "./DescriptionNews.css";

const DescriptionNews = ({ isAlbanian, newsId }) => {
  const [news, setNews] = useState([]);
  useEffect(() => {
    if (!newsId) return;

    const foundNews = newsData.find(
      (n) => String(n.news_id) === String(newsId)
    );

    if (foundNews) {
      setNews(foundNews);
    } else {
      console.error(`News with id ${newsId} not found in news.json`);
    }
  }, [newsId]);

  if (!news) {
    return <div className="loading-screen">Loading description...</div>;
  }

  return (
    <div>
      <div className="descriptionnews-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="descriptionnews-title">
            {isAlbanian ? news.titull_lajmesh : news.news_title}
          </div>
          <div className="descriptionnews-paragraph">
            {isAlbanian
              ? news.pershkrim_lajmesh?.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    <p>{line}</p>
                  </React.Fragment>
                ))
              : news.news_description?.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    <p>{line}</p>
                  </React.Fragment>
                ))}
          </div>

          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default DescriptionNews;
